export const membershipCompany = {
	init: () => {
		const wrapper = document.querySelector( '.member-page.member-company' );

		if ( wrapper ) {
			limitDocNumber( wrapper );
			initImageRemoval( wrapper );
			const moreBtn = wrapper.querySelector( 'button.add-more' );
			if ( moreBtn ) {
				moreBtn.addEventListener( 'click', function() {
					addDocForm( wrapper );
				} );
			}
		}
	},
};

function addDocForm( wrapper ) {
	const documentsWrapper = wrapper.querySelector( '.documents-wrapper' );
	const docForm = documentsWrapper.querySelector( '.document' ).cloneNode( true );
	const index = documentsWrapper.querySelectorAll( '.document' ).length + 1;
	resetDocForm( docForm, index );
	documentsWrapper.appendChild( docForm );
	limitDocNumber( wrapper );
}

function resetDocForm( form, index ) {
	form.innerHTML = form.innerHTML.replaceAll( /company_doc_(new_)*\d+/gm, 'company_doc_new_' + index );
	form.innerHTML = form.innerHTML.replaceAll( /company_doc\[(new_)*\d+]/gm, 'company_doc[new_' + index + ']' );
	const inputs = form.querySelectorAll( 'input, textarea' );
	inputs.forEach( ( input ) => {
		input.value = '';
	} );
}

function limitDocNumber( wrapper ) {
	const maxDoc = 3;
	const documentsWrapper = wrapper.querySelector( '.documents-wrapper' );
	if ( documentsWrapper ) {
		const currentDocCount = documentsWrapper.querySelectorAll( '.document' ).length;
		if ( currentDocCount >= maxDoc ) {
			const moreBtn = wrapper.querySelector( 'button.add-more' );
			moreBtn.classList.add( 'hidden' );
		}
	}
}

function initImageRemoval( wrapper ) {
	const documentsWrapper = wrapper.querySelector( '.documents-wrapper' );
	if ( documentsWrapper ) {
		documentsWrapper.addEventListener( 'click', function( e ) {
			if ( e.target.classList.contains( 'remove-image' ) ) {
				const imageWrapper = e.target.closest( '.image-upload' );
				imageWrapper.querySelector( '.image-wrapper' ).remove();
				imageWrapper.querySelector( '.remove-image-checkbox' ).checked = true;
			}
		} );
	}
}
